import { render, staticRenderFns } from "./CmgNutritionCalculatorRecentsCard.vue?vue&type=template&id=8648c338&scoped=true&lang=pug&"
import script from "./cmg-nutrition-calculator-recents-card.ts?vue&type=script&lang=ts&"
export * from "./cmg-nutrition-calculator-recents-card.ts?vue&type=script&lang=ts&"
import style0 from "./CmgNutritionCalculatorRecentsCard.vue?vue&type=style&index=0&id=8648c338&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8648c338",
  null
  
)

export default component.exports